export default __webpack_public_path__ + "static/media/spin-bg-7.0f01d737.png";